import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Import24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M4.46939 12C4.46939 7.84096 7.84096 4.46939 12 4.46939C16.159 4.46939 19.5306 7.84096 19.5306 12C19.5306 16.159 16.159 19.5306 12 19.5306C7.84096 19.5306 4.46939 16.159 4.46939 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM12 6.85718C12.0996 6.85718 12.1946 6.877 12.2812 6.91293L12.5199 7.07275L15.2746 9.82747C15.5615 10.1144 15.5615 10.5796 15.2746 10.8665C14.9877 11.1534 14.5225 11.1534 14.2356 10.8665L12.7347 9.36558V15.8572C12.7347 16.2629 12.4057 16.5919 12 16.5919C11.5942 16.5919 11.2653 16.2629 11.2653 15.8572V9.36558L9.76439 10.8665C9.47748 11.1534 9.0123 11.1534 8.72538 10.8665C8.43846 10.5796 8.43846 10.1144 8.72538 9.82747L11.4805 7.07236C11.5509 7.00192 11.6321 6.94878 11.7188 6.91293C11.8054 6.877 11.9004 6.85718 12 6.85718Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
